module.exports = __webpack_public_path__ + "img/arrowUp.6fba79f9.svg";